"use strict";

module.exports = over;
function over(lens, cb, value) {
  var l = lens(value);
  return l.set(cb(l.get()));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/over/over.js
// module id = 523
// module chunks = 0